import {curry} from 'ramda';

export default curry((property, value, node) => (node[property] = value, node));
